import { useContext } from 'react';
import { PaymentContext } from './PaymentContext';

export const usePaymentContext = () => useContext(PaymentContext);
